import Ineligible from './Ineligible';
export default Ineligible;
